/* ------------------------------------------------------------------
 * Auth constants (shared client + server)
 * ------------------------------------------------------------------ */

/** HttpOnly cookie that stores the Firebase session cookie (14-day lifetime) */
export const SESSION_COOKIE = "netic_session";

/** HttpOnly cookie that stores the currently-selected tenant UUID */
export const TENANT_COOKIE = "netic_active_tenant";

/**
 * HttpOnly cookie that carries the impersonated user's email across requests.
 * Set / cleared exclusively via POST/DELETE `/api/dashboard/spoof` — never
 * derived from URL params, since prerendered pages would otherwise be served
 * from the edge cache without invoking middleware to set it.
 */
export const SPOOF_COOKIE = "netic_spoof_email";

/**
 * HttpOnly cookie set for netic_view users. When present, request-proxy rejects
 * non-GET writes the same way spoof sessions do.
 */
export const NETIC_VIEW_READONLY_COOKIE = "netic_view_readonly";

/** Sentinel meaning “show data for *all* tenants” in UI state */
export const ALL_TENANTS_ID = "ALL";

/** 14 days expressed in *seconds* (Firebase + Set-Cookie) */
export const SESSION_MAX_AGE_SEC = 60 * 60 * 24 * 14;
